import API_URL from '../../constants/url'
import { logUtil } from 'packages/src'
import fetchNetworkUtil from '../../../../utils/network/fetch'

export async function putApi ({
  endpoint,
  data,
  jwt
}) {
  if (!endpoint) {
    logUtil('putApi')
      .error(`[no data] endpoint '${endpoint}': `, data)
    return
  }
  const response = await fetchNetworkUtil(`${API_URL}${endpoint}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`
    },
    method: 'PUT',
    body: JSON.stringify(data)
  })
  if (!response.ok) {
    throw (
      await response.json()
    )
  }
  return response.json()
}
